import { camelize as fastCamelize, pascalize } from 'fast-case';

export const camelize = (obj: any, options?: { pascalCase?: boolean }) => {
  // deep is already handled by fast-case
  if (options?.pascalCase) {
    return pascalize(obj);
  }
  return fastCamelize(obj);
};
